var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 10.4482C4.89999 10.4482 4 11.3586 4 12.4713C4 13.5839 4.89999 14.4943 5.99999 14.4943C7.09998 14.4943 7.99998 13.5839 7.99998 12.4713C7.99998 11.3586 7.09998 10.4482 5.99999 10.4482ZM17.9999 10.4482C16.8999 10.4482 15.9999 11.3586 15.9999 12.4713C15.9999 13.5839 16.8999 14.4943 17.9999 14.4943C19.0999 14.4943 19.9999 13.5839 19.9999 12.4713C19.9999 11.3586 19.0999 10.4482 17.9999 10.4482ZM12 10.4482C10.9 10.4482 9.99996 11.3586 9.99996 12.4713C9.99996 13.5839 10.9 14.4943 12 14.4943C13.0999 14.4943 13.9999 13.5839 13.9999 12.4713C13.9999 11.3586 13.0999 10.4482 12 10.4482Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftMore);
export default __webpack_public_path__ + "static/media/shiftMore.bca3adb4e4cfff50cfc8b1fadf091078.svg";
export { ForwardRef as ReactComponent };